// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0px;
  background-color: #000000;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Center the buttons and add spacing */
.App {
  text-align: center;
}
.App-header {
  background-color: #000000;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.app-container {

}

.chart-and-tables-container {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  width: 100%; /* Ensure the container takes the full width */
  margin-bottom: 20px;
}

@media (max-width: 1080px) {
  .chart-and-tables-container {
    flex-direction: column; /* Stack chart and tables vertically on smaller screens */
    margin-right: 20px; /* Remove fixed margin */

  }

  .chart-container, .tables-container {
    width: 100%; /* Allow these containers to take full width on smaller screens */
    align-items: center;
    margin-right: 0; /* Remove fixed margin */
  }

  .tables-container .table {
    max-width: 50%; /* Make table width responsive */
    align-items: center;

  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW,EAAE,8CAA8C;EAC3D,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB,EAAE,yDAAyD;IACjF,kBAAkB,EAAE,wBAAwB;;EAE9C;;EAEA;IACE,WAAW,EAAE,iEAAiE;IAC9E,mBAAmB;IACnB,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,cAAc,EAAE,gCAAgC;IAChD,mBAAmB;;EAErB;AACF","sourcesContent":["body {\n  margin: 0px;\n  background-color: #000000;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Center the buttons and add spacing */\n.App {\n  text-align: center;\n}\n.App-header {\n  background-color: #000000;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.app-container {\n\n}\n\n.chart-and-tables-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  width: 100%; /* Ensure the container takes the full width */\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1080px) {\n  .chart-and-tables-container {\n    flex-direction: column; /* Stack chart and tables vertically on smaller screens */\n    margin-right: 20px; /* Remove fixed margin */\n\n  }\n\n  .chart-container, .tables-container {\n    width: 100%; /* Allow these containers to take full width on smaller screens */\n    align-items: center;\n    margin-right: 0; /* Remove fixed margin */\n  }\n\n  .tables-container .table {\n    max-width: 50%; /* Make table width responsive */\n    align-items: center;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
